import DatacorLogoSpinner from '../../../../../../components/datacorLogoSpinner/DatacorLogoSpinner';
import React from 'react';
import FormPartial from '../../../../../../components/form/formContainer/FormPartial';
import SubSection9_2Form from './subSections/subSection9_2/SubSection9_2Form';
import SdsPropertyGrid from './subSections/subSection9_1/SdsPropertyGrid';
import { SdsHeader, SdsProperty } from '../../../../../../types/formulation';
import { SdsBlobSectionFormProps } from '../shared/blobs/hooks/SdsBlobSectionFormProps';
import TranslatableText from '../../../../../../components/i18n/TranslatableText';
import { SDSFormDefs } from '../../../../../../constants/i18n/translations/termDefinitions/formulation';
import { ChildEditableGridWithCopyFunctionProps } from '../../../../../grid/utils/editableGrid/ChildEditableGridWithCopyFunctionProps';

const SdsPhysicalAndChemicalProperForm = (
    props: ChildEditableGridWithCopyFunctionProps<SdsHeader, SdsProperty> &
        SdsBlobSectionFormProps<SdsHeader>
) => {
    const { isParentLoading } = props.parentData;

    return (
        <>
            {isParentLoading ? (
                <DatacorLogoSpinner />
            ) : (
                <>
                    <FormPartial
                        link={props?.link}
                        title={
                            (
                                <TranslatableText
                                    termSet={props.termSet}
                                    termKey={SDSFormDefs.Physical_Chemical}
                                />
                            ) as unknown as string
                        }>
                        <SdsPropertyGrid {...props} />
                        <SubSection9_2Form {...props} termSet={props.termSet} />
                    </FormPartial>
                </>
            )}
        </>
    );
};

export default SdsPhysicalAndChemicalProperForm;
